(function () {
  if (window.__sdTrustMateProductRatingsReady) return;
  window.__sdTrustMateProductRatingsReady = true;

  var ratingEndpointBase = 'https://trustmate.pro/platforms/product/ratings/';
  var defaultReviewTargetId = 'd303063e-4c4a-432b-8e80-5fd2ef3706c4';
  var defaultPlatformId = 'b7bf395f-e074-4376-b0a1-3f7bc341d437';
  var cache = {};

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function opinionPlural(count) {
    var absolute = Math.abs(count);
    var lastDigit = absolute % 10;
    var lastTwoDigits = absolute % 100;
    if (absolute === 1) return 'opinia';
    if (lastDigit >= 2 && lastDigit <= 4 && !(lastTwoDigits >= 12 && lastTwoDigits <= 14)) return 'opinie';
    return 'opinii';
  }

  function formatRating(value) {
    return toNumber(value).toLocaleString('pl-PL', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });
  }

  function cacheKey(platformId, variantId) {
    return String(platformId) + ':' + String(variantId);
  }

  function normalizeItem(item) {
    if (!item) return null;
    var rating = toNumber(item.averageGrade || item.average || item.rating || item.ratingValue);
    var count = Math.round(toNumber(item.reviewsCount || item.reviewCount || item.ratingCount || item.count));
    if (!rating || !count) return null;
    return { rating: rating, count: count };
  }

  function setRating(node, ratingValue, reviewCount) {
    var rating = toNumber(ratingValue);
    var count = Math.round(toNumber(reviewCount));
    if (!rating || !count) return false;

    var stars = node.querySelector('[data-sd-trustmate-card-stars]');
    var label = node.querySelector('[data-sd-trustmate-card-label]');
    if (!stars || !label) return false;

    stars.style.width = Math.max(0, Math.min(100, (rating / 5) * 100)).toFixed(2) + '%';
    label.textContent = formatRating(rating) + ' / 5 (' + count + ' ' + opinionPlural(count) + ')';
    node.setAttribute(
      'aria-label',
      'Ocena ' + formatRating(rating) + ' na 5 na podstawie ' + count + ' ' + opinionPlural(count) + '. Przejdź do opinii klientów.'
    );
    node.hidden = false;
    return true;
  }

  function renderCached(node) {
    var platformId = node.getAttribute('data-platform-id');
    var variantId = node.getAttribute('data-variant-id');
    var item = cache[cacheKey(platformId, variantId)];
    return item ? setRating(node, item.rating, item.count) : false;
  }

  function fetchPlatformRatings(platformId, nodes) {
    var ids = [];
    nodes.forEach(function (node) {
      var variantId = node.getAttribute('data-variant-id');
      if (!variantId || renderCached(node)) return;
      if (ids.indexOf(variantId) === -1) ids.push(variantId);
    });
    if (!platformId || !ids.length) return;

    var params = new URLSearchParams();
    ids.forEach(function (id) {
      params.append('products[]', id);
    });

    fetch(ratingEndpointBase + encodeURIComponent(platformId) + '?' + params.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('TrustMate rating request failed');
        return response.json();
      })
      .then(function (data) {
        var items = Array.isArray(data && data.items) ? data.items : [];
        items.forEach(function (entry) {
          var localId = entry && entry.localId;
          var normalized = normalizeItem(entry);
          if (localId && normalized) cache[cacheKey(platformId, localId)] = normalized;
        });
        nodes.forEach(renderCached);
      })
      .catch(function () {
        // Leave cards hidden if TrustMate does not return product data.
      });
  }

  function bindRatings(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('[data-sd-trustmate-card-rating]'));
    var groups = {};

    nodes.forEach(function (node) {
      if (node.dataset.sdTrustMateCardBound === '1') {
        renderCached(node);
        return;
      }
      node.dataset.sdTrustMateCardBound = '1';
      var platformId = node.getAttribute('data-platform-id');
      if (!platformId) return;
      groups[platformId] = groups[platformId] || [];
      groups[platformId].push(node);
    });

    Object.keys(groups).forEach(function (platformId) {
      fetchPlatformRatings(platformId, groups[platformId]);
    });
  }

  function readCachedItems(platformId, ids) {
    return ids.map(function (variantId) {
      return cache[cacheKey(platformId, variantId)];
    }).filter(Boolean);
  }

  function setAggregateRating(node, platformId, ids) {
    var items = readCachedItems(platformId, ids);
    var totalCount = items.reduce(function (sum, item) {
      return sum + item.count;
    }, 0);
    if (!totalCount) return false;

    var weightedTotal = items.reduce(function (sum, item) {
      return sum + (item.rating * item.count);
    }, 0);
    var average = weightedTotal / totalCount;
    var ratingNode = node.querySelector('[data-sd-trustmate-aggregate-rating-value]');
    var countNode = node.querySelector('[data-sd-trustmate-aggregate-count]');
    var headingNode = node.querySelector('[data-sd-trustmate-aggregate-heading]');
    if (!ratingNode || !countNode) return false;

    ratingNode.textContent = '★ ' + formatRating(average) + ' / 5';
    countNode.textContent = totalCount + ' ' + opinionPlural(totalCount) + ' TrustMate';
    if (headingNode && !headingNode.dataset.sdTrustMateHeadingUpdated) {
      headingNode.textContent = 'Średnia ocena produktów Psorisel';
      headingNode.dataset.sdTrustMateHeadingUpdated = '1';
    }
    node.setAttribute(
      'aria-label',
      'Średnia ocena produktów Psorisel ' + formatRating(average) + ' na 5 na podstawie ' + totalCount + ' ' + opinionPlural(totalCount) + ' TrustMate.'
    );
    return true;
  }

  function fetchAggregateRatings(platformId, ids, nodes) {
    var missingIds = ids.filter(function (variantId) {
      return !cache[cacheKey(platformId, variantId)];
    });
    if (!platformId || !ids.length) return;
    if (!missingIds.length) {
      nodes.forEach(function (node) {
        setAggregateRating(node, platformId, ids);
      });
      return;
    }

    var params = new URLSearchParams();
    missingIds.forEach(function (id) {
      params.append('products[]', id);
    });

    fetch(ratingEndpointBase + encodeURIComponent(platformId) + '?' + params.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('TrustMate aggregate rating request failed');
        return response.json();
      })
      .then(function (data) {
        var items = Array.isArray(data && data.items) ? data.items : [];
        items.forEach(function (entry) {
          var localId = entry && entry.localId;
          var normalized = normalizeItem(entry);
          if (localId && normalized) cache[cacheKey(platformId, localId)] = normalized;
        });
        nodes.forEach(function (node) {
          setAggregateRating(node, platformId, ids);
        });
      })
      .catch(function () {
        // Keep the Theme Editor fallback copy visible.
      });
  }

  function bindAggregateRatings(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('[data-sd-trustmate-aggregate-rating]'));
    var groups = {};

    nodes.forEach(function (node) {
      var platformId = node.getAttribute('data-platform-id');
      var ids = (node.getAttribute('data-variant-ids') || '').split(',').map(function (id) {
        return id.trim();
      }).filter(Boolean);
      if (!platformId || !ids.length) return;
      var key = platformId + ':' + ids.join(',');
      groups[key] = groups[key] || { platformId: platformId, ids: ids, nodes: [] };
      groups[key].nodes.push(node);
    });

    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      fetchAggregateRatings(group.platformId, group.ids, group.nodes);
    });
  }

  function setInlineArticleProductRating(card) {
    var variantId = card.getAttribute('data-variant-id');
    var item = cache[cacheKey(defaultPlatformId, variantId)];
    var ratingRoot = card.querySelector('.psorisel-lp__product-rating');
    if (!variantId || !item || !ratingRoot) return false;

    var score = ratingRoot.querySelector('.psorisel-lp__product-score');
    var count = ratingRoot.querySelector('.psorisel-lp__product-opinions');

    if (!score) {
      score = Array.prototype.slice.call(ratingRoot.children).find(function (child) {
        return !child.classList.contains('psorisel-lp__product-stars') && !child.classList.contains('psorisel-lp__product-opinions');
      });
    }

    if (score) {
      score.classList.add('psorisel-lp__product-score');
      score.textContent = formatRating(item.rating) + ' / 5';
    }
    if (count) {
      count.textContent = '(' + item.count + ' ' + opinionPlural(item.count) + ')';
    }
    ratingRoot.setAttribute(
      'aria-label',
      'Ocena ' + formatRating(item.rating) + ' na 5 na podstawie ' + item.count + ' ' + opinionPlural(item.count) + ' TrustMate.'
    );
    return true;
  }

  function fetchInlineArticleProductRatings(cards) {
    var ids = [];
    cards.forEach(function (card) {
      var variantId = card.getAttribute('data-variant-id');
      if (!variantId || setInlineArticleProductRating(card)) return;
      if (ids.indexOf(variantId) === -1) ids.push(variantId);
    });
    if (!ids.length) return;

    var params = new URLSearchParams();
    ids.forEach(function (id) {
      params.append('products[]', id);
    });

    fetch(ratingEndpointBase + encodeURIComponent(defaultPlatformId) + '?' + params.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('TrustMate inline article rating request failed');
        return response.json();
      })
      .then(function (data) {
        var items = Array.isArray(data && data.items) ? data.items : [];
        items.forEach(function (entry) {
          var localId = entry && entry.localId;
          var normalized = normalizeItem(entry);
          if (localId && normalized) cache[cacheKey(defaultPlatformId, localId)] = normalized;
        });
        cards.forEach(setInlineArticleProductRating);
      })
      .catch(function () {
        // Keep article fallback copy visible.
      });
  }

  function bindInlineArticleProductRatings(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('.psorisel-lp__product-card[data-variant-id]'));
    if (!cards.length) return;
    fetchInlineArticleProductRatings(cards);
  }

  function findReviewTarget(hash) {
    var targetId = hash ? hash.replace(/^#/, '') : '';
    return (targetId && document.getElementById(targetId))
      || document.getElementById(defaultReviewTargetId)
      || document.querySelector('.hydra')
      || document.querySelector('[data-trustmate-widget="social-proof-product"]');
  }

  function scrollToReviewTargetFromHash() {
    var hash = window.location.hash || '';
    if (
      hash !== '#' + defaultReviewTargetId &&
      hash !== '#trustmate-opinie' &&
      hash !== '#opinie'
    ) {
      return;
    }

    var startedAt = Date.now();
    var timer = window.setInterval(function () {
      var target = findReviewTarget(hash);
      if (target) {
        window.clearInterval(timer);
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () {
          target.focus({ preventScroll: true });
        }, 400);
      } else if (Date.now() - startedAt > 8000) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  ready(function () {
    bindRatings(document);
    bindAggregateRatings(document);
    bindInlineArticleProductRatings(document);
    scrollToReviewTargetFromHash();

    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              bindRatings(node);
              bindAggregateRatings(node);
              bindInlineArticleProductRatings(node);
            }
          });
        });
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  });
})();
